
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/apollo-jbp-hospitals",
      function () {
        return require("private-next-pages/case-study/apollo-jbp-hospitals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/apollo-jbp-hospitals"])
      });
    }
  